import React from 'react'
import { FaFacebook } from 'react-icons/fa'

export default function Menu({ close }) {
  return (
    <div className="menu-overlay">
      <div className="menu-content">
        <button className="menu-close" onClick={close}>X</button>

        {/* Contact */}
        <div className="menu-section">
          <h3>Contact</h3>
          <p>Email: <a href="mailto:support@cuvia.ro">support@cuvia.ro</a></p>
          <p>
            Facebook:
            <a href="https://www.facebook.com/profile.php?id=100085404132412" target="_blank" rel="noopener noreferrer">
              <FaFacebook style={{ marginLeft: '5px' }} />
            </a>
          </p>
        </div>

        {/* Impresii si recenzii */}
        <div className="menu-section">
          <h3>Impresii & Recenzii</h3>
          <p>Vezi parerile utilizatorilor despre platforma Cuvia.</p>
          <a href="#reviews-tab" className="menu-link">Acceseaza Recenziile</a>
        </div>

        {/* Donatii */}
        <div className="menu-section">
          <h3>Donatii</h3>
          <ul className="donation-list">
            <li>
              PayPal: <a href="https://paypal.me/SNegrean" target="_blank" rel="noopener noreferrer">@SNegrean</a>
            </li>
            <li>
              Wise: <span>@steliangabrieln</span>
            </li>
          </ul>
        </div>

        {/* Terms & Privacy */}
        <div className="menu-section">
          <h3>Termeni si Confidentialitate</h3>
          <a href="/terms_and_privacy.html" className="menu-link">Vezi detalii</a>
        </div>
      </div>
    </div>
  )
}
